module.exports = __webpack_public_path__ + "static/media/book-reader.f684326a.svg";